import { observer } from 'mobx-react';
import * as React from 'react';
import ProgramStore from '../../../ProgramStore';
import { T } from '../../../Translations';
import * as style from '../style.module.css';
import ProgressMessage from './ProgressMessage';

interface Props {
  programStore: ProgramStore;
}
const ProgressSection: React.FC<Props> = ({ programStore }) => {
  const percentComplete = Math.round(programStore.percentComplete.getOrElseValue(0));

  return (
    <section className={style.section}>
      <h3 className={style.supPanelHeader} data-test-section-header="Progress">
        <T kind="Progress" />
      </h3>
      <div className={style.progress}>
        <div
          className={style.progressBar}
          role="progressbar"
          aria-valuenow={percentComplete}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Course progress"
        >
          <div
            className={style.progressFill}
            data-complete={percentComplete}
            data-test-progress-bar={true}
          />
        </div>
      </div>
      <div
        className={style.progressDesc}
        data-test-module-completion-count={true}
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        <ProgressMessage programStore={programStore} />
      </div>
    </section>
  );
};

export default observer(ProgressSection);
